import {
    ArrowRightIcon,
    BaseIcon,
    ButtonLabel,
} from '@moreharvest/component-library';
import { ctaClick } from '@services/analytics';
import { FormattedMessage } from '@utils/i18n';
import { AnalyticsCtaId } from 'mh-client';
import { Link } from 'react-router';

const CompleteAccountCta = ({
    id,
    screenName,
}: {
    id?: string;
    screenName?: string;
}) => {
    return (
        <Link
            to="/profile/bank-details-form"
            id={id ?? 'profileVerified_CTA_completeSetup'}
            onClick={() => {
                if (screenName) {
                    ctaClick({
                        screen_name: screenName,
                        cta_id: AnalyticsCtaId.getInstance()
                            .COMPLETE_ACCOUNT_SETUP,
                    });
                }
            }}
        >
            <ButtonLabel size="small" variant="solid" fit>
                <FormattedMessage id="complete_account_setup" />
                <BaseIcon size="small">
                    <ArrowRightIcon className="fill-base-black" />
                </BaseIcon>
            </ButtonLabel>
        </Link>
    );
};

export default CompleteAccountCta;
